import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useEffect } from 'react';
import tabbable from 'tabbable'; // TODO(DISC-1141): write unit tests

var FocusTrap = function FocusTrap(_ref) {
  var containerRef = _ref.containerRef,
      children = _ref.children,
      customInitialFocus = _ref.customInitialFocus;
  var previousFocusEl = useRef(null);
  var getTabbableElements = useCallback(function () {
    if (!containerRef.current) {
      throw new Error('Could not initialize focus-trapping - container is missing');
    }

    var tabbableEls = tabbable(containerRef.current);

    if (!tabbableEls.length) {
      throw new Error('Could not initialize focus-trapping - focusable elements are missing');
    }

    return tabbableEls;
  }, [containerRef]);
  var focusFirstTabbableElement = useCallback(function () {
    var tabbableEls = getTabbableElements();
    tabbableEls[0].focus();
  }, [getTabbableElements]);
  var focusLastTabbableElement = useCallback(function () {
    var tabbableEls = getTabbableElements();
    tabbableEls[tabbableEls.length - 1].focus();
  }, [getTabbableElements]);
  useEffect(function () {
    previousFocusEl.current = document.activeElement;
    customInitialFocus ? customInitialFocus(getTabbableElements()) : focusFirstTabbableElement();
    return function () {
      if (previousFocusEl.current) {
        previousFocusEl.current.focus();
      }
    };
  }, [customInitialFocus, focusFirstTabbableElement, getTabbableElements]);
  return jsxs(Fragment, {
    children: [jsx("i", {
      "aria-hidden": true,
      onFocus: focusLastTabbableElement,
      tabIndex: 0
    }), children, jsx("i", {
      "aria-hidden": true,
      onFocus: focusFirstTabbableElement,
      tabIndex: 0
    })]
  });
};

export { FocusTrap };